import React from 'react';
import { range } from 'lodash';
import { Row, Col, Card, CardBody } from 'reactstrap';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cn from 'classnames';
import { withRouter } from 'react-router-dom';
import qs from 'query-string';
import $ from 'jquery';
import { paths, clientSortTypes } from '../../../../../common/constants';

import selectors from './selectors';

import { DotLoader } from 'react-spinners';

import moment from 'moment';
import actions from '../../actions';
import { ConfirmActionModal } from '../../components';
import Moment from 'react-moment';
import EditCustomerModal from '../../components/EditCustomerModal';

class Customers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sortTypes: {
        no: true,
        username: true,
        email: true,
        posts_count: true,
        trips_count: true,
        status: true,
      },
      keyword: '',
      limit: 10,
      activeFilter: 'createdAt',
      showArchived: false,
      start_at: 1,
      customerToDelete: null,
      customerToSuspend: null,
      selectedCustomer: {},
      customers: [],
      pageNumber: 1,
      endofPage: false,
      posttable: false,
      userid: '',
    };

    this.handleGetCustomers = this.handleGetCustomers.bind(this);
    this.toggleSortTypesState = this.toggleSortTypesState.bind(this);
    this.handleDeleteCustomer = this.handleDeleteCustomer.bind(this);
    this.handleSuspendCustomer = this.handleSuspendCustomer.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputEnter = this.handleInputEnter.bind(this);
    this.handleChangeLimit = this.handleChangeLimit.bind(this);
    this.handlePagination = this.handlePagination.bind(this);
    this.handleGetPosts = this.handleGetPosts.bind(this);
    this.redirectToCustomer = this.redirectToCustomer.bind(this);
    this.onCheckboxChange = this.onCheckboxChange.bind(this);
    this.openModal = this.openModal.bind(this);

    this.deleteCustomerModalId = 'deleteCustomerModal';
    this.suspendCustomerModalId = 'suspendCustomerModal';
    this.editCustomer = 'editCustomer';
  }

  componentDidMount() {
    const {
      getCustomers,
      location: { search },
    } = this.props;

    getCustomers(qs.parse(search))
      .then(({ result: { data } }) => {
        const customers = data.data;
        const { total, start_at, limit } = data;
        this.setState({ customers, total, start_at, limit });
      })
      .catch(() => {
        toast.error('Internal Server Error');
      });
  }

  onCheckboxChange({ target: { checked } }) {
    this.setState({ showArchived: checked }, () => {
      const { showArchived } = this.state;
      this.handleGetCustomers({ showArchived });
    });
  }

  toggleSortTypesState(sortType) {
    const { sortTypes } = this.state;
    this.setState({
      sortTypes: {
        ...sortTypes,
        [sortType]: !sortTypes[sortType],
      },
      activeFilter: sortType,
    });
  }

  redirectToCustomer(customer) {
    const {
      history: { push },
    } = this.props;
    push(paths.build(paths.client.ADMIN_CUSTOMER_DETAIL, customer._id));
  }

  openModal(modalToShow, customer) {
    if (modalToShow === this.deleteCustomerModalId) {
      this.setState({ customerToDelete: customer }, () => {
        $(`#${modalToShow}`).modal('show');
      });
    }
    if (modalToShow === this.suspendCustomerModalId) {
      this.setState({ customerToSuspend: customer }, () => {
        $(`#${modalToShow}`).modal('show');
      });
    } else {
      this.setState({ ...this.state, selectedCustomer: customer });
      $(`#${modalToShow}`).modal('show');
    }
  }

  handleInputChange(e) {
    this.setState({
      keyword: e.target.value,
    });
  }

  handleInputEnter(e) {
    if (e.key === 'Enter') {
      const {
        location: { search },
      } = this.props;

      const { sortTypes, activeFilter, limit, keyword } = this.state;

      const parsedSearch = qs.parse(search);

      this.handleGetCustomers(
        {
          ...parsedSearch,
          asc: !sortTypes.username,
          sortBy: clientSortTypes.username,
          limit,
          keyword,
        },
        activeFilter,
      );
    }
  }

  handleGetPosts(customer_id, posts_count) {
    const { getPostsByUserID } = this.props;

    console.log(customer_id, posts_count);

    this.setState({
      posttable: true,
      userid: customer_id,
      limit: posts_count,
      endofPage: true,
    });

    getPostsByUserID({ customer_id, limit: posts_count })
      .then(({ result: { data } }) => {
        console.log(data);
        const { posts_start_at, limit } = data;
        const posts = data.data;
        this.setState({ posts, posts_start_at, limit });
      })
      .catch(e => console.log(e));
  }

  handleChangeLimit(e) {
    const {
      location: { search },
    } = this.props;

    const { sortTypes, activeFilter, limit } = this.state;

    const parsedSearch = qs.parse(search);
    if (e.target.value === 'All') {
      this.setState({
        limit: e.target.value,
        endofPage: true,
      });
    } else {
      this.setState({
        limit: e.target.value,
        endofPage: false,
      });
    }

    this.handleGetLimitCustomers(
      {
        ...parsedSearch,
        asc: !sortTypes.username,
        sortBy: clientSortTypes.username,
        limit: e.target.value,
        keyword: this.keyword,
      },
      activeFilter,
    );
  }

  handlePagination(query, pageNumber) {
    const { getCustomers } = this.props;
    getCustomers(query)
      .then(({ result: { data } }) => {
        const customers = data.data;
        const { total, start_at, limit } = data;

        if (limit !== this.state.limit) {
          this.setState({
            customers,
            total,
            start_at,
            pageNumber,
            endofPage: true,
          });
        } else {
          this.setState({
            customers,
            total,
            start_at,
            limit,
            pageNumber,
            endofPage: false,
          });
        }
      })
      .catch(() => {
        toast.error('Internal Server Error');
      });
  }

  handleReloadCustomers() {
    const {
      getCustomers,
      location: { search },
    } = this.props;

    getCustomers(qs.parse(search)); //
  }

  handleGetCustomers(params, sortTypes = null) {
    const { getCustomers } = this.props;

    if (sortTypes) {
      this.toggleSortTypesState(sortTypes);
    }

    // getCustomers(params);
    getCustomers(params)
      .then(({ result: { data } }) => {
        const customers = data.data;
        const { total, start_at, limit } = data;
        this.setState({ customers, total, start_at, limit });
      })
      .catch(() => {
        toast.error('Internal Server Error');
      });
  }

  handleGetLimitCustomers(params, sortTypes = null) {
    const { getCustomers } = this.props;

    if (sortTypes) {
      this.toggleSortTypesState(sortTypes);
    }

    // getCustomers(params);
    getCustomers(params)
      .then(({ result: { data } }) => {
        const customers = data.data;
        const { total, start_at, limit } = data;

        this.setState({ customers, total, start_at, limit });
      })
      .catch(() => {
        toast.error('Internal Server Error');
      });
  }

  handleDeleteCustomer() {
    const { deleteCustomer } = this.props;
    const { customers, customerToDelete } = this.state;

    deleteCustomer(customerToDelete._id)
      .then(() => {
        this.setState({
          customers: customers.filter(el => el._id !== customerToDelete._id),
        });
        toast.success('Customer was removed successfully');
      })
      .catch(() => toast.error('Internal Server Error'));
  }

  handleSuspendCustomer() {
    const { updateCustomer } = this.props;
    const { customers, customerToSuspend } = this.state;

    // updateCustomer(customerToSuspend._id, {suspended_at: moment().toDate()})
    // .then(() => {
    //   // this.setState({
    //   //   customers: customers.filter(el=>el._id !== customerToDelete._id)
    //   // });
    //   // toast.success("Customer was removed successfully")
    // }).catch(() => toast.error("Internal Server Error"));
  }

  render() {
    const {
      isCustomersLoaded,
      location: { search },
    } = this.props;
    const {
      customers,
      sortTypes,
      activeFilter,
      customerToDelete,
      customerToSuspend,
      keyword,
      limit,
      start_at,
      total,
      pageNumber,
    } = this.state;
    const parsedSearch = qs.parse(search);

    const TablePagination = (props) => {
      const { total, limit, start_at, onPagination } = props;
      const numberOfPages = Math.ceil(total / limit) || 1;
      const paginationContent = range(1, numberOfPages + 1).map((pageNumber) => {
        const active = pageNumber * limit === start_at - 1;
        return (
          <div key={pageNumber} className={cn('page-item', { active })}>
            {this.state.endofPage === false ? (
              <button
                className="page-link"
                onClick={() => {
                    onPagination(
                      {
                        start_at,
                        limit,
                        keyword: keyword.length > 0 ? keyword : null,
                      },
                      pageNumber,
                    );
                  }}
              >
                  Next
              </button>
              ) : null}
          </div>
        );
      });

      return (
        <div className="d-flex `table-pagination` float-right">
          {paginationContent}
        </div>
      );
    };

    const TableContent = () => customers.map((customer, key) => (
      <tr key={key}>
        <td>{(pageNumber - 1) * limit + key + 1}</td>
        <td>{customer._id}</td>
        <td>{customer.username}</td>
        <td>{customer.email}</td>
        <td>
          <button
            onClick={() =>
                this.handleGetPosts(customer._id, customer.posts_count)
              }
          >
            {customer.posts_count}
          </button>
        </td>
        <td>
          {customer.createdAt ? (
            <Moment format="YYYY/MM/DD hh:mm">{customer.createdAt}</Moment>
            ) : (
              '-'
            )}
        </td>
        <td>
          <i
            className="fa fa-eye table-action-but"
            onClick={() => this.redirectToCustomer(customer, 1)}
          >
            {' '}
            <span className="tooltiptext">View account</span>{' '}
          </i>
          <i
            className="fa fa-pencil table-action-but"
            onClick={() => {
                  this.openModal(this.editCustomer, customer);
                }
              }
          >
            {' '}
            <span className="tooltiptext">Edit account</span>{' '}
          </i>
          <i
            className="fa fa-lock table-action-but"
            onClick={() => {
              this.openModal(this.suspendCustomerModalId, customer);
            }}
          >
            {' '}
            <span className="tooltiptext">Suspend account</span>{' '}
          </i>
          <i
            className="fa fa-trash table-action-but"
            onClick={() =>
                this.openModal(this.deleteCustomerModalId, customer)
              }
          >
            {' '}
            <span className="tooltiptext">Delete account</span>{' '}
          </i>
        </td>
      </tr>
    ));

    const PostsTableContent = () => (this.state.posts
      ? this.state.posts.map((item, key) => (
        <tr key={key}>
          <td>{(pageNumber - 1) * limit + key + 1}</td>
          <td>{item._id}</td>
          <td>{item.title}</td>
          <td>{item.customerInfo.email}</td>
          <td>{item.price}</td>
          <td>
            <Moment format="YYYY/MM/DD hh:mm">
              {item.createdAt || item.updatedAt}
            </Moment>
          </td>
          {/* <td>
                <i
                  className="fa fa-pencil table-action-but"
                  onClick={() => this.redirectToPost(item)}
                >
                  {" "}
                  <span className="tooltiptext">Edit post</span>{" "}
                </i>
                <i
                  className="fa fa-lock table-action-but"
                  onClick={() => this.openModal(this.suspendPostModalId, item)}
                >
                  {" "}
                  <span className="tooltiptext">Suspend post</span>{" "}
                </i>
                <i
                  className="fa fa-trash table-action-but"
                  onClick={() => this.openModal(this.deletePostModalId, item)}
                >
                  {" "}
                  <span className="tooltiptext">Delete post</span>{" "}
                </i>
              </td> */}
        </tr>
      ))
      : null);

    const deleteCustomerModal = customerToDelete ? (
      <ConfirmActionModal
        id={this.deleteCustomerModalId}
        itemBeingDeleted={customerToDelete}
        onConfirm={this.handleDeleteCustomer}
        text={`Are you sure you want to delete ${customerToDelete.username}`}
        title="Delete"
        isDeleteModal
      />
    ) : null;

    const suspendCustomerModal = customerToSuspend ? (
      <ConfirmActionModal
        id={this.suspendCustomerModalId}
        itemBeingDeleted={customerToSuspend}
        onConfirm={this.handleSuspendCustomer}
        text={`Are you sure you want to suspend ${customerToSuspend.username}`}
        title="Suspend"
        isDeleteModal
      />
    ) : null;
    const content = (
      <section>
        {deleteCustomerModal}
        {suspendCustomerModal}
        <div className="row mb-4">
          <div className="col-sm-12 col-md-6 col-align-left">
            <div className="align-vertical">
              <label>Show entries</label>
              <select
                className="custom-select custom-select-sm form-control form-control-sm"
                onChange={this.handleChangeLimit}
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="All">All</option>
              </select>
            </div>
          </div>
          <div className="col-sm-12 col-md-6 col-align-right">
            <div className="align-vertical">
              <label>Search Email</label>
              <input
                type="search"
                className="form-control form-control-sm search-input-box"
                placeholder="Type and enter to search"
                value={keyword}
                onChange={this.handleInputChange}
                onKeyDown={this.handleInputEnter}
              />
            </div>
          </div>
        </div>
        <div className="row mb-4">
          <div className="col">
            <div id="customers">
              {this.state.userid}
              <table
                className="table table-striped table-bordered table-sm"
                cellSpacing="0"
                width="100%"
              >
                <thead>
                  <tr>
                    <th
                      className="th-sm"
                      onClick={() =>
                        this.handleGetCustomers(
                          {
                            ...parsedSearch,
                            asc: !sortTypes.no,
                            sortBy: clientSortTypes.no,
                            limit,
                          },
                          'no',
                        )
                      }
                    >
                      <div className="d-flex">
                        <div className="th-title">No</div>
                        <i
                          className={cn('fa ml-2 fa-caret-up', {
                            isActive:
                              sortTypes[activeFilter] && activeFilter === 'no',
                          })}
                        />
                        <i
                          className={cn('fa ml-2 fa-caret-down', {
                            isActive:
                              !sortTypes[activeFilter] && activeFilter === 'no',
                          })}
                        />
                      </div>
                    </th>
                    <th
                      className="th-sm"
                      onClick={() =>
                        this.handleGetCustomers(
                          {
                            ...parsedSearch,
                            asc: !sortTypes.username,
                            sortBy: clientSortTypes.username,
                            limit,
                          },
                          'username',
                        )
                      }
                    >
                      <div className="d-flex">
                        <div className="th-title">User ID</div>
                        <i
                          className={cn('fa ml-2 fa-caret-up', {
                            isActive:
                              sortTypes[activeFilter] &&
                              activeFilter === 'username',
                          })}
                        />
                        <i
                          className={cn('fa ml-2 fa-caret-down', {
                            isActive:
                              !sortTypes[activeFilter] &&
                              activeFilter === 'username',
                          })}
                        />
                      </div>
                    </th>
                    <th
                      className="th-sm"
                      onClick={() =>
                        this.handleGetCustomers(
                          {
                            ...parsedSearch,
                            asc: !sortTypes.username,
                            sortBy: clientSortTypes.username,
                            limit,
                          },
                          'username',
                        )
                      }
                    >
                      <div className="d-flex">
                        <div className="th-title">Name</div>
                        <i
                          className={cn('fa ml-2 fa-caret-up', {
                            isActive:
                              sortTypes[activeFilter] &&
                              activeFilter === 'username',
                          })}
                        />
                        <i
                          className={cn('fa ml-2 fa-caret-down', {
                            isActive:
                              !sortTypes[activeFilter] &&
                              activeFilter === 'username',
                          })}
                        />
                      </div>
                    </th>
                    <th
                      className="th-sm"
                      onClick={() =>
                        this.handleGetCustomers(
                          {
                            ...parsedSearch,
                            asc: !sortTypes.email,
                            sortBy: clientSortTypes.email,
                            limit,
                          },
                          'email',
                        )
                      }
                    >
                      <div className="d-flex">
                        <div className="th-title">Email</div>
                        <i
                          className={cn('fa ml-2 fa-caret-up', {
                            isActive:
                              sortTypes[activeFilter] &&
                              activeFilter === 'email',
                          })}
                        />
                        <i
                          className={cn('fa ml-2 fa-caret-down', {
                            isActive:
                              !sortTypes[activeFilter] &&
                              activeFilter === 'email',
                          })}
                        />
                      </div>
                    </th>
                    <th
                      className="th-sm"
                      onClick={() =>
                        this.handleGetCustomers(
                          {
                            ...parsedSearch,
                            asc: !sortTypes.posts_count,
                            sortBy: clientSortTypes.posts_count,
                            limit,
                          },
                          'posts_count',
                        )
                      }
                    >
                      <div className="d-flex">
                        <div className="th-title">Posts Count</div>
                        <i
                          className={cn('fa ml-2 fa-caret-up', {
                            isActive:
                              sortTypes[activeFilter] &&
                              activeFilter === 'posts_count',
                          })}
                        />
                        <i
                          className={cn('fa ml-2 fa-caret-down', {
                            isActive:
                              !sortTypes[activeFilter] &&
                              activeFilter === 'posts_count',
                          })}
                        />
                      </div>
                    </th>
                    <th className="th-sm">Date</th>
                    <th className="th-sm">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.posttable === false ? (
                    <TableContent />
                  ) : (
                    <PostsTableContent />
                  )}
                </tbody>
              </table>
              <TablePagination
                total={total}
                limit={limit}
                start_at={start_at}
                onPagination={this.handlePagination}
              />

              {!isCustomersLoaded ? (
                <div className="spinner-container">
                  <DotLoader sizeUnit="px" size={50} color="#00DD8C" />
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </section>
    );

    return (
      <React.Fragment>
        <Row>
          <Col xs="12">
            <Card>
              <CardBody>
                {this.state.selectedCustomer ? <EditCustomerModal id={this.editCustomer} customer={this.state.selectedCustomer} /> : null}
                {content}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

Customers.defaultProps = {};

Customers.propTypes = {
  isCustomersLoaded: PropTypes.bool.isRequired,
  customers: PropTypes.object.isRequired,
  getCustomers: PropTypes.func.isRequired,
  deleteCustomer: PropTypes.func.isRequired,
  updateCustomer: PropTypes.func.isRequired,
  getPostsByUserID: PropTypes.func.isRequired,
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
};

export default connect(selectors, {
  ...actions.customers,
})(withRouter(Customers));



// WEBPACK FOOTER //
// ./client/react/Admin/views/Customers/index.jsx